export default __webpack_public_path__ + "static/media/pictogramBeaconTransfer40.edce21e0.svg";